import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {useForm} from "react-hook-form";
import classes from './form.module.scss';
import {singIn} from "./UserTagData";
import {useNavigate} from 'react-router-dom';
import errorMessage from "../../../../const/Tost";
import {AuthService} from "../../../../api/authService";
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';

const AddUser = () => {
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: {errors},
    } = useForm();

    const values = singIn;
    const navigate = useNavigate();
    const role = watch('role');


    const [fileName, setFileName] = useState("Оберіть файл");
    const [base64String, setBase64String] = useState("");
    const role2 = useSelector(state => state.login.userInfo.permissions.users_manage)

    useEffect(() => {
        if (!role2){
            navigate('/Home')
            toast.error('В доступі відмовлено!')
        }
    }, [])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file){
            setFileName(file.name);  // Set the file name to display in the label
            const reader = new FileReader();

            reader.onload = () => {
                const base64 = reader.result.split(",")[1];  // Extract the base64 string
                setBase64String(base64);
            };

            reader.readAsDataURL(file);  // Read the file as a data URL (base64)
        }
    };

    const onSubmit = async(data) => {
        try{
            if (base64String){
                data['certificate'] = base64String;
            }

            if (data.roleLabel === 'medicalDirector'){
                data['permissions'] = {
                    contracts_manage: false,
                    hospitals_manage: false,
                    users_manage: false,
                    statistic: false,
                    users_activity: false,
                };
            }

            if (data.roleLabel === "admin"){
                data['permissions'] = {
                    contracts_manage: true,
                    hospitals_manage: true,
                    users_manage: true,
                    statistic: true,
                    users_activity: true,
                };
            }


            if (data.roleLabel === "laboratoryAssistant"){
                data['permissions'] = {
                    scaning_print: true,
                }
            }

            if (data.roleLabel === "assistant"){
                data['permissions'] = {
                    scaning_print: false,
                }
            }

            await AuthService.register(data).then(res => {
                if (res) navigate('/WorkersList')
            });
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
    console.log(values.fields)
    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.form__wrapper}>
                    <div className={classNames(classes.form__title)}>
                        Реєстрація нового працівника
                    </div>
                </div>
                {[...values.fields]
                    .sort((a, b) => {
                        if (a.name === 'surname' && b.name === 'name') return -1;
                        if (a.name === 'name' && b.name === 'surname') return 1;
                        return 0;
                    }).map((el, index) => (
                        <div className={classes[values.class]} key={index}>
                            <legend className={classes.form__label} htmlFor={el.type}>{el.legend}</legend>
                            <div
                                className={classNames(
                                    el.name == 'cassetsAfter'
                                        ? classes.form__input__cassets
                                        : classes.form__label__container,
                                    {[classes.register__container]: values.formType == 'singIn'}
                                )}
                            >
                                {el.options ? (
                                    <>
                                        <label>{el?.label}</label>
                                        <select
                                            name={el.name}
                                            className={classes.form__select}
                                            {...register('roleLabel')} // регистрируем именно roleLabel
                                            onChange={(e) => {
                                                // при смене выбираем объект по roleLabel
                                                const selectedRoleLabel = e.target.value;
                                                const selectedOption = el.props.find(opt => opt.roleLabel === selectedRoleLabel);

                                                // обновляем значение roleLabel и, если нужно, значение роли
                                                setValue('roleLabel', selectedRoleLabel);
                                                setValue(el.name, selectedOption?.value || '');
                                            }}
                                            defaultValue=""
                                        >
                                            {el.props.map((props, i) => (
                                                <option key={props.id + i} className={classes.form__option} value={props.roleLabel}>
                                                    {props.name}
                                                </option>
                                            ))}
                                        </select>
                                    </>
                                ) : (
                                    <>
                                        {el.props.map((props, i) => (
                                            <div
                                                className={classNames(
                                                    classes.form__label__container__box,
                                                    {[classes.register__container]: values.formType == 'singIn'}
                                                )}
                                                key={'a' + i}
                                            >
                                                <div><label>{props.label}</label></div>
                                                {el.type === 'file' ? (
                                                    <div className={classes.form__fileInput__wrapper}>
                                                        <label className={classes.form__fileInput__label}>
                                                            {fileName}
                                                            <input
                                                                className={classNames(classes.form__fileInput, {[classes.errorInput]: errors[el.name]})}
                                                                type='file'
                                                                placeholder={props.placeholder}
                                                                onChange={(e) => handleFileChange(e)}
                                                            />
                                                        </label>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <div className={el.name == 'cassetsAfter' ? classes.form__input__cassets : {}}>
                                                            <input
                                                                className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                                type={props.type}
                                                                min={props.min}
                                                                max={props.max}
                                                                disabled={props.show}
                                                                placeholder={props.placeholder}
                                                                pattern={props.pattern}
                                                                value={el.type == 'radio' ? props.label : props.value}
                                                                {...register(
                                                                    el.name == 'age' || el.name == 'cassetsAfter'
                                                                        ? props.register
                                                                        : el.name,
                                                                    {required: el.required}
                                                                )}
                                                            />
                                                        </div>

                                                        {errors[el.name] && (
                                                            <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                                Це поле є обов'язковим
                                                            </p>
                                                        )}
                                                    </div>
                                                )}

                                            </div>
                                        ))}
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                <button className={classes.form__button} type="submit">{values.button}</button>
            </form>
        </>
    );
}

export default AddUser;
